import { partnersConstants as C } from "../actions/constants";

const init = {
  items: [],
  loading: false,
  error: null,

  // пагинация/фильтры
  page: 0,
  pageSize: 12,
  totalAll: 0,
  totalPages: 0,

  sort: "createdAtMinus",
  search: "",
};

export default function partners(state = init, action) {
  switch (action.type) {
    case C.GET_PARTNERS_REQUEST:
      return { ...state, loading: true, error: null };
    case C.GET_PARTNERS_SUCCESS: {
      const { items, page, pageSize, totalAll, totalPages, sort, search } = action.payload;
      return {
        ...state,
        loading: false,
        items,
        page,
        pageSize,
        totalAll,
        totalPages,
        sort,
        search,
      };
    }
    case C.GET_PARTNERS_FAILURE:
      return { ...state, loading: false, error: "Ошибка загрузки" };

    case C.SET_PAGE:
      return { ...state, page: action.payload };
    case C.SET_PAGE_SIZE:
      return { ...state, pageSize: action.payload, page: 0 };
    case C.SET_SORT:
      return { ...state, sort: action.payload, page: 0 };
    case C.SET_SEARCH:
      return { ...state, search: action.payload, page: 0 };

    default:
      return state;
  }
}
